import { createSelector } from "reselect";

import { ReservedSavedAddressType } from "@mapmycustomers/shared/enum/SavedAddressType";
import SavedAddress from "@mapmycustomers/shared/types/SavedAddress";

import { RootState } from "@app/store/rootReducer";

const savedLocationsState = (state: RootState) => state.savedLocations;

export const areSavedAddressesLoaded = createSelector(
  savedLocationsState,
  ({ savedAddresses }) => !!savedAddresses
);

export const getSavedAddresses = createSelector(
  savedLocationsState,
  ({ savedAddresses }) => savedAddresses ?? []
);

export const getSavedAddressLimit = createSelector(savedLocationsState, ({ limit }) => limit);

export const isSavedAddressLimitReached = createSelector(
  savedLocationsState,
  ({ limit, savedAddresses }) =>
    !!savedAddresses && limit !== undefined && savedAddresses.length >= limit
);

export const getSavedAddressById = (state: RootState, id: SavedAddress["id"]) =>
  getSavedAddresses(state).find((savedAddress) => savedAddress.id === id);

export const getReservedSavedAddress = (state: RootState, type: ReservedSavedAddressType) =>
  getSavedAddresses(state).find((savedAddress) => savedAddress.type === type);
